const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    user_category_ids: {
      type: 'array',
      title: 'گروه',
      items: [],
    },
    is_active: {
      type: 'number',
      title: 'وضعیت',
      oneOf: [
        { const: 0, title: 'غیرفعال' },
        { const: 1, title: 'فعال' },
      ],
    },
  },
});

export default schema;
